import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SignalIcon, PhoneIcon, DatabaseIcon, MessageSquareIcon, ActivityIcon, ChevronRightIcon } from 'lucide-react';
const MOCK_CALLS = [{
  id: 1,
  number: '+1 (555) 012-3456',
  duration: '4:12',
  summary: 'Client requested Q3 pricing update for enterprise fleet rollout.'
}, {
  id: 2,
  number: '+1 (555) 987-6543',
  duration: '1:45',
  summary: 'Follow-up on hardware financing terms for 50 new iPhone 15s.'
}, {
  id: 3,
  number: '+1 (555) 246-8135',
  duration: '12:30',
  summary: 'Technical deep dive on AVA AI transcription latency and security.'
}, {
  id: 4,
  number: '+1 (555) 369-2580',
  duration: '2:15',
  summary: 'Scheduling demo for autonomous workflow automation suite.'
}];
export function ConsoleMockup() {
  const [activeTab, setActiveTab] = useState('lines');
  const [visibleCalls, setVisibleCalls] = useState(MOCK_CALLS.slice(0, 2));
  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleCalls(prev => {
        const next = MOCK_CALLS[Math.floor(Math.random() * MOCK_CALLS.length)];
        return [next, ...prev.slice(0, 2)];
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section id="console" className="py-20 bg-gray-50 relative overflow-hidden" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-4xl font-black tracking-tighter text-black mb-4 uppercase italic" data-id="element-26">
            Customer <span className="text-[#13E200]" data-id="element-27">Console</span>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto font-bold uppercase tracking-widest text-xs leading-relaxed" data-id="element-28">
            Manage your entire autonomous fleet from a single, high-fidelity
            dashboard.
          </p>
        </div>

        <div className="bg-white rounded-[2rem] overflow-hidden shadow-xl border-4 border-black" data-id="element-29">
          <div className="bg-gray-100 border-b-2 border-black p-4 flex justify-between items-center" data-id="element-30">
            <div className="flex items-center gap-4" data-id="element-31">
              <div className="flex gap-1.5" data-id="element-32">
                <div className="w-3 h-3 rounded-full bg-gray-300" data-id="element-33" />
                <div className="w-3 h-3 rounded-full bg-gray-300" data-id="element-34" />
                <div className="w-3 h-3 rounded-full bg-gray-300" data-id="element-35" />
              </div>
              <div className="h-4 w-px bg-gray-300 mx-2" data-id="element-36" />
              <span className="text-xs font-mono text-gray-400" data-id="element-37">
                EFFY-CONSOLE-V1.0.4
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-38">
              <div className="w-2 h-2 rounded-full bg-[#13E200] animate-pulse" data-id="element-39" />
              <span className="text-[10px] font-bold text-black uppercase tracking-widest" data-id="element-40">
                System Online
              </span>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row h-[600px]" data-id="element-41">
            <div className="w-full lg:w-64 bg-white border-r border-gray-100 p-4 flex flex-col gap-2" data-id="element-42">
              {[{
              id: 'lines',
              label: 'Active Lines',
              icon: SignalIcon
            }, {
              id: 'ava',
              label: 'AVA Analytics',
              icon: ActivityIcon
            }, {
              id: 'billing',
              label: 'Fleet Billing',
              icon: DatabaseIcon
            }, {
              id: 'support',
              label: 'Shield Support',
              icon: MessageSquareIcon
            }].map(item => <button key={item.id} onClick={() => setActiveTab(item.id)} className={`flex items-center gap-3 px-4 py-4 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${activeTab === item.id ? 'bg-[#13E200] text-black shadow-md' : 'text-gray-400 hover:bg-gray-50'}`} data-id="element-43">
                  <item.icon className="w-4 h-4" data-id="element-44" />
                  {item.label}
                </button>)}
            </div>

            <div className="flex-1 flex flex-col lg:flex-row overflow-hidden" data-id="element-45">
              <div className="flex-1 p-6 border-r border-gray-100 overflow-y-auto" data-id="element-46">
                <h3 className="text-sm font-black uppercase tracking-widest text-black mb-6" data-id="element-47">
                  Provisioned Fleet
                </h3>
                <div className="space-y-4" data-id="element-48">
                  {[{
                  number: '+1 (555) 102-9384',
                  user: 'Sarah Chen',
                  status: 'online',
                  data: '12.4 GB'
                }, {
                  number: '+1 (555) 482-1102',
                  user: 'Marcus Thorne',
                  status: 'online',
                  data: '4.2 GB'
                }, {
                  number: '+1 (555) 992-3841',
                  user: 'Elena Rodriguez',
                  status: 'offline',
                  data: '0.0 GB'
                }, {
                  number: '+1 (555) 221-0092',
                  user: 'David Kim',
                  status: 'online',
                  data: '28.1 GB'
                }].map((line, i) => <div key={i} className="bg-white border border-gray-100 rounded-xl p-4 hover:border-[#13E200] transition-colors group shadow-sm" data-id="element-49">
                      <div className="flex justify-between items-start mb-3" data-id="element-50">
                        <div data-id="element-51">
                          <p className="text-sm font-black text-black" data-id="element-52">
                            {line.number}
                          </p>
                          <p className="text-xs text-gray-400 font-medium" data-id="element-53">
                            {line.user}
                          </p>
                        </div>
                        <div className={`px-2 py-1 rounded text-[8px] font-black uppercase tracking-widest ${line.status === 'online' ? 'bg-[#13E200]/10 text-[#13E200] border border-[#13E200]/20' : 'bg-gray-100 text-gray-400 border border-gray-200'}`} data-id="element-54">
                          {line.status}
                        </div>
                      </div>
                      <div className="flex items-center gap-4" data-id="element-55">
                        <div className="flex-1 h-1 bg-gray-100 rounded-full overflow-hidden" data-id="element-56">
                          <div className="h-full bg-[#13E200]" style={{
                        width: `${parseFloat(line.data) / 30 * 100}%`
                      }} data-id="element-57" />
                        </div>
                        <span className="text-[10px] font-mono text-gray-400" data-id="element-58">
                          {line.data} / 30GB
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>

              <div className="w-full lg:w-96 p-6 bg-gray-50 overflow-hidden flex flex-col" data-id="element-59">
                <h3 className="text-sm font-black uppercase tracking-widest text-black mb-6" data-id="element-60">
                  AVA Call Analytics Log
                </h3>
                <div className="flex-1 space-y-4 overflow-y-auto pr-2 custom-scrollbar" data-id="element-61">
                  {visibleCalls.map((call, i) => <motion.div key={`${call.id}-${i}`} initial={{
                  opacity: 0,
                  x: 20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} className="bg-white border border-gray-100 rounded-2xl p-5 relative overflow-hidden shadow-sm" data-id="element-62">
                      <div className="absolute top-0 right-0 p-4" data-id="element-63">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#13E200] animate-pulse shadow-sm" data-id="element-64" />
                      </div>
                      <div className="flex items-center gap-4 mb-4" data-id="element-65">
                        <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center border border-gray-100" data-id="element-66">
                          <PhoneIcon className="w-5 h-5 text-black" data-id="element-67" />
                        </div>
                        <div data-id="element-68">
                          <p className="text-xs font-black text-black uppercase tracking-widest" data-id="element-69">
                            {call.number}
                          </p>
                          <p className="text-[10px] text-gray-400 font-mono" data-id="element-70">
                            {call.duration} Duration
                          </p>
                        </div>
                      </div>
                      <div className="bg-gray-50 rounded-xl p-4 border border-gray-100" data-id="element-71">
                        <p className="text-[8px] font-black text-[#13E200] mb-2 uppercase tracking-[0.2em]" data-id="element-72">
                          AVA JSON Summary
                        </p>
                        <p className="text-xs text-gray-500 leading-relaxed italic" data-id="element-73">
                          "{call.summary}"
                        </p>
                      </div>
                    </motion.div>)}
                </div>
                <button className="mt-6 w-full py-4 bg-white/5 hover:bg-white/10 rounded-xl text-[10px] font-black text-white/40 hover:text-white flex items-center justify-center gap-2 transition-all uppercase tracking-widest" data-id="element-74">
                  View Full Inference Logs{' '}
                  <ChevronRightIcon className="w-4 h-4" data-id="element-75" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}